import '@/assets/styles/components/phone-input.styles.scss';
import { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';
import { ImageWithFallback } from '@/components';
import { PhoneInputProps } from './phone-input.types';

export const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(({ value, onChange, disabled, name }, ref) => {
	return (
		<div className="form-group-container">
			<h3>Cep Telefonu</h3>
			<div className="phone-input">
				<div className="country-code">
					<ImageWithFallback
						alt="Türk Bayrağı"
						src="turkey-flag.svg"
					/>
					<span>+90</span>
				</div>
				<IMaskInput
					ref={ref}
					name={name}
					mask="(000) 000 00 00"
					definitions={{
						'0': /[0-9]/
					}}
					type="phone"
					onAccept={value => onChange(value)}
					unmask
					value={value}
					disabled={disabled}
					placeholder="(5__) ___ __ __"
				/>
			</div>
		</div>
	);
});

PhoneInput.displayName = 'PhoneInput';
